(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular
    .module('app')
    .component('bookingItemNotificationProviderPage', bookingItemNotificationProviderComponent());

  function bookingItemNotificationProviderComponent() {
    return {
      bidings: {},
      controller: BookingItemNotificationProviderCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/booking-item-notification-provider/' +
        'booking-item-notification-provider-page.component.html',
    };
  }

  BookingItemNotificationProviderCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$routeParams',
    '$translate',
    'BookingItemNotificationProviderService',
    'BookingService',

    // Angular downgraded service
    'ng2Router',
  ];

  function BookingItemNotificationProviderCtrl(
    config,
    UtilService,
    $routeParams,
    $translate,
    BookingItemNotificationProviderService,
    BookingService,

    // Angular downgraded service
    ng2Router
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.bookingItemType = $routeParams.tp; // it-> booking item / sv -> booking item service item

    // If user tries to enter other values in the url
    if (vm.bookingItemType !== 'it' && vm.bookingItemType !== 'sv') {
      ng2Router.navigate(['/ng/login']);
    }

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY;

    let notificationId = $routeParams.id; // bookingItemNotificationId / bookingItemServiceItemNotificationId
    vm.subdomain = $routeParams.subdomain;
    vm.companyApiKey = $routeParams.companyApiKey;
    let lang = $routeParams.lang;

    vm.notificationStatus = 'confirm';

    vm.confirmBtnStyle = {
      color: '#499249',
      'font-size': '100px',
    };

    vm.declineBtnStyle = {
      color: 'gray',
      'font-size': '100px',
    };

    vm.$onInit = function () {
      // if ($translate.use() !== lang){
      $translate.use(lang);
      // }

      // Initializers
      getBookingItemNotificationProvider();
    };

    vm.changeNotificationStatus = function (status) {
      if (status) {
        vm.notificationStatus = 'confirm';
        vm.confirmBtnStyle.color = '#499249';
        vm.declineBtnStyle.color = 'gray';
      } else {
        vm.notificationStatus = 'decline';
        vm.confirmBtnStyle.color = 'gray';
        vm.declineBtnStyle.color = '#a9302a';
      }
    };

    vm.getTotalPax = function (adults, children, infants, seniors, option) {
      return BookingService.getTotalPax(adults, children, infants, seniors, option);
    };

    vm.onBookingItemNotificationConfirmed = function (dataObj) {
      vm.bookingItemData.status = dataObj.status;
    };

    vm.onBookingItemNotificationDeclined = function (dataObj) {
      vm.bookingItemData.status = dataObj.status;
    };

    function getBookingItemNotificationProvider() {
      vm.loadingNotification = true;

      let notificationUrl =
        vm.bookingItemType === 'it'
          ? 'booking_item_notifications_provider'
          : 'booking_item_service_item_notifications_provider';

      BookingItemNotificationProviderService.getBookingItemNotificationProvider(
        notificationId,
        vm.subdomain,
        vm.companyApiKey,
        notificationUrl,
        lang
      ).then(function (data) {
        if (data) {
          vm.company = data.company;
          vm.website = data.website;

          vm.notification = data.notification;
          vm.bookingItem = data.booking_item;
          vm.booking = data.booking;

          if (vm.bookingItemType === 'it') {
            vm.bookingItemData = vm.bookingItem;
            vm.bookingItemDataServiceName = vm.bookingItemData.detail.name;
          } else {
            vm.bookingItemServiceItem = data.booking_item_service_item;

            vm.bookingItemData = vm.bookingItemServiceItem;
            vm.bookingItemDataServiceName = vm.bookingItemData.service_item.name;
          }

          vm.totalPax = BookingService.getTotalPax(
            vm.bookingItemData.adults,
            vm.bookingItemData.children,
            vm.bookingItemData.infants,
            vm.bookingItemData.seniors
          );

          vm.loadingNotification = false;
        } else {
          ng2Router.navigate(['/ng/login']);
        }
      });
    }
  }
})();
